import React from "react";
import { useHistory } from "react-router-dom";
import "../Styles/Footer.scss";
import ciqlerCurvedLogo from "../../Assets/Images/Ciqler footer logo.png";
import { IoMdMail, IoLogoTwitter } from "react-icons/io";
import { IoLogoLinkedin, IoLogoInstagram } from "react-icons/io5";

import { useTranslation } from "react-i18next";

const Navbar = () => {
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <div>
      <div className="footer-bar bg-green-100">
        <div className="floating-img-footer">
          <img
            className="gift-bot-logo-01-3-footer"
            src={ciqlerCurvedLogo}
            alt="floataya"
          />
        </div>
        <p className="p-footer">{t("common.copyright")}</p>
        <div className="container-footer">
          <IoMdMail
            className="symbol hover:cursor-pointer"
            onClick={() => window.open("mailto:hello@ciqler.com")}
          />
          <IoLogoInstagram
            className="symbol hover:cursor-pointer"
            onClick={() => window.open("https://www.instagram.com/_ciqler/")}
          />
          <IoLogoLinkedin
            className="symbol hover:cursor-pointer"
            onClick={() =>
              window.open("https://www.linkedin.com/company/ciqler")
            }
          />
          <IoLogoTwitter
            className="symbol hover:cursor-pointer"
            onClick={() => window.open("https://twitter.com/_ciqler")}
          />
        </div>
      </div>
    </div>
  );
};

export default Navbar;
